<template>
  <el-dialog :visible="detailDialogVisible" title="审核" @close="closeDialog" width="30%">
    <el-form label-width="100px">
      <el-form-item label="是否通过:">
        <el-select v-model="statue" placeholder="请选择状态">
          <el-option v-for="item in aduitArr" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>

      </el-form-item>
      <el-form-item label="备注:">
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入备注" v-model="remark"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="toggleDetailDialogVisible(false)">取消</el-button>
      <el-button type="primary" @click="submit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import ImageWrapper from 'components/image';
import api from '../../api'

export default {
  name: 'AuditDetail',
  props: ['value'],
  components: {
    ImageWrapper
  },
  data() {
    return {
      aduitArr: [
        { label: '审核通过', key: -1, },
        { label: '审核不通过', key: 0, }
      ],
      statue: "",
      remark: ""
    }
  },
  methods: {
    ...mapActions('otcAudit', [
      'detail',
      'details',
    ]),
    ...mapMutations('otcAudit', ['toggleDetailDialogVisible']),
    submit() {
      if (this.statue === '' || this.statue == null) {
        return this.$message.error('请先选择状态！')
      }
      api.otcAudit({
        id: this.value,
        statue: this.statue,
        remark: this.remark,
      }).then(res => {
        if (res.code == 0) {
          this.$emit('onUpdate')
          this.closeDialog()
        }
      })
    },
    closeDialog() {
      this.toggleDetailDialogVisible(false);
      this.reset()
    },
    reset() {
      this.statue = '';
      this.remark = '';
    }
  },
  computed: {
    ...mapState('otcAudit', ['detailDialogVisible']),
  }
};
</script>

<style lang="less" scoped>
@import '~styles/variables.less';

.reason-input {
  width: 100%;

  /deep/ .el-textarea__inner {
    border-color: @color-danger;
    background-color: lighten(@color-danger, 25%);
    resize: none;
    color: #333;
  }
}
</style>
